import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { CheckIcon } from 'lucide-react';
import { ImageGallery } from '../components/ImageGallery';
export default function SpainPage() {
  const spainImages = [{
    src: 'https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Beautiful Andalusian landscape'
  }, {
    src: 'https://images.unsplash.com/photo-1554629947-334ff61d85dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1036&q=80',
    alt: 'Spanish mountains and valleys'
  }, {
    src: 'https://images.unsplash.com/photo-1586861256632-52a3db3369be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Spanish countryside'
  }, {
    src: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80',
    alt: 'Malaga cityscape'
  }];
  const visualImpressions = [{
    src: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80',
    alt: 'Malaga cathedral',
    description: 'The magnificent Cathedral of Malaga, built between 1528-1782'
  }, {
    src: 'https://images.unsplash.com/photo-1564713908744-e2a3acd4037d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Nerja coastline',
    description: 'The beautiful fishing village of Nerja on the Mediterranean coast'
  }, {
    src: 'https://images.unsplash.com/photo-1591971737811-a56afa55ccc3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Alcazaba',
    description: 'The historic Alcazaba, a Moorish fortress with Arabic and Roman influences'
  }, {
    src: 'https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Andalusian countryside',
    description: 'Explore the beautiful natural areas of Andalusia during guided walks'
  }];
  return <div className="flex flex-col min-h-screen w-full" data-id="element-661">
      <Header data-id="element-662" />
      <main className="flex-grow" data-id="element-663">
        {/* Hero Section */}
        <section className="relative w-full h-[60vh] bg-cover bg-center" data-id="element-664">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80')"
        }} data-id="element-665">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-666"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-667">
            <div className="max-w-3xl text-white" data-id="element-668">
              <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-669">
                Discover Andalucia from the inside
              </h1>
              <p className="text-lg md:text-xl mb-8" data-id="element-670">
                Spain is of course a very well-known country among tourists,
                because of the pleasant climate, the beautiful nature, the
                beaches, culturally interesting cities and buildings and not to
                forget the delicious Spanish dishes, which you can enjoy
                endlessly on a terrace in the sun.
                <br data-id="element-671" />
                <br data-id="element-672" />
                We would like to take you to the south of Spain. With an expert
                of the area you will discover the fascinating city of Malaga,
                spend the night in the cozy fishing village of Nerja, in an area
                where you can also enjoy wonderful walks. In short, all the
                ingredients are present for a relaxing holiday week in a group.
              </p>
              <a href="/join" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md text-center inline-block transition duration-300" data-id="element-673">
                Join a Trip
              </a>
            </div>
          </div>
        </section>
        {/* Trip Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-674">
          <div className="container mx-auto px-4" data-id="element-675">
            <div className="text-center mb-12" data-id="element-676">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-677">
                Our Spain Hiking Trips
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-678">
                Explore the stunning landscapes and rich culture of Spain with
                our guided hiking tours
              </p>
            </div>
            <div className="grid grid-cols-1 gap-8 max-w-4xl mx-auto" data-id="element-679">
              {/* Trip 1 */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-680">
                <div className="relative h-64" data-id="element-681">
                  <img src="https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80" alt="Andalusian hiking week" className="w-full h-full object-cover" data-id="element-682" />
                </div>
                <div className="p-6" data-id="element-683">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-684">
                    Andalusian hiking week
                  </h3>
                  <p className="text-teal-600 font-semibold mb-4" data-id="element-685">
                    21 - 28 September 2025
                  </p>
                  <p className="text-gray-600 mb-6" data-id="element-686">
                    Andalusia is an autonomous Spanish region in the far south
                    of Spain. The region is divided into 8 provinces.
                    <br data-id="element-687" />
                    <br data-id="element-688" />
                    In addition to the capital Seville, there are more beautiful
                    cities such as Ronda, Granada, Cordoba and Malaga.
                    <br data-id="element-689" />
                    <br data-id="element-690" />
                    This 8-day walking and cultural trip focuses on the province
                    of Malaga.
                    <br data-id="element-691" />
                    <br data-id="element-692" />
                    We will stay in the beautiful fishing town of Nerja on the
                    Mediterranean Sea, approximately 40 km east of Malaga.
                    <br data-id="element-693" />
                    <br data-id="element-694" />
                    From there we will undertake various walks and visit the
                    city of Malaga and other cultural sights.
                  </p>
                  <div className="space-y-2 mb-6" data-id="element-695">
                    <div className="flex items-start" data-id="element-696">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-697" />
                      <span className="text-gray-700" data-id="element-698">
                        Small group (max. 12 people)
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-699">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-700" />
                      <span className="text-gray-700" data-id="element-701">
                        Local guide with expert knowledge of Andalusia
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-702">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-703" />
                      <span className="text-gray-700" data-id="element-704">
                        Mix of cultural visits and scenic hiking trails
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-800 font-medium mb-6" data-id="element-705">
                    8-day hiking trip from € 845,- per person
                  </p>
                  <a href="/trips/andalusia" className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-706">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Spain Gallery Section */}
        <section className="py-16 w-full" data-id="element-707">
          <div className="container mx-auto px-4" data-id="element-708">
            <ImageGallery images={spainImages} data-id="element-709" />
            <div className="max-w-4xl mx-auto mt-12" data-id="element-710">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-711">
                Andalusia
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-712">
                Andalusia is an autonomous Spanish region in the far south of
                Spain. The region is divided into 8 provinces. In addition to
                the capital Seville, there are more beautiful cities such as
                Ronda, Granada, Cordoba and Malaga.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-713">
                A trip to Andalusia will be an experience that you will
                remember.
                <br data-id="element-714" />
                <br data-id="element-715" />
                You will be immersed in the cultural highlights of the area,
                discover botanical gardens, caves and a plantation.
                <br data-id="element-716" />
                <br data-id="element-717" />
                We can enjoy the natural areas during beautiful walks, special
                architecture and cozy shops and stay in a picturesque fishing
                village on the Mediterranean Sea.
              </p>
              <h3 className="text-2xl font-bold text-gray-800 mt-8 mb-4" data-id="element-718">
                The city of Malaga
              </h3>
              <p className="text-lg text-gray-700 mb-6" data-id="element-719">
                Malaga, a fascinating city with many sights.
                <br data-id="element-720" />
                <br data-id="element-721" />
                For example, we will visit the Cathedral of Malaga, which took
                200 years to build (1528-1782). The Cathedral was never
                completely finished, which can be seen from the towers; the
                right tower was never built. In addition to the beautiful
                exterior, we also visit the interior, where a guided tour with
                information with a header is given.
                <br data-id="element-722" />
                <br data-id="element-723" />
                The most common artist Picasso was born in Malaga and there is
                therefore a Picasso Museum, which is more than worth a visit.
                The permanent exhibition mainly consists of works from the first
                and last period of Picasso.
                <br data-id="element-724" />
                <br data-id="element-725" />
                A walk through the Alcazaba is special because you can taste the
                history of Malaga there. The Alcazaba is a Moorish fortress with
                Arabic and Roman influences. A walk through the wonderful
                gardens and enjoying beautiful views from the walls of the
                Alcazaba over the historic center of Malaga are part of this
                visit.
                <br data-id="element-726" />
                <br data-id="element-727" />
                More places in Malaga are worth a visit. Opposite the Alcazaba
                is the Roman theatre Romano, which can be seen clearly from the
                Calle Alcazabilla. A walk through the Calle Molina Lario, one of
                the most beautiful shopping streets, is also worthwhile.
                <br data-id="element-728" />
                <br data-id="element-729" />A lunch on the atmospheric Plaza del Obispo (opposite the
                Cathedral) or the Placa de la Merced is possible. And of course
                it is possible to stroll through the beautiful city centre with
                its many shops and terraces.
              </p>
              <p className="text-lg italic text-gray-600 mb-6" data-id="element-730">
                This offer is covered by the STO Garant guarantee. You can find
                the conditions for this guarantee scheme on STO Garant's website
                (www.sto-garant.nl/en/downloads).
              </p>
            </div>
          </div>
        </section>
        {/* Visual Impression Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-731">
          <div className="container mx-auto px-4" data-id="element-732">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12 text-center" data-id="element-733">
              A Visual Impression
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-734">
              {visualImpressions.map((image, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-735">
                  <div className="h-64 overflow-hidden" data-id="element-736">
                    <img src={image.src} alt={image.alt} className="w-full h-full object-cover transform hover:scale-105 transition duration-500" data-id="element-737" />
                  </div>
                  <div className="p-4" data-id="element-738">
                    <p className="text-gray-700" data-id="element-739">{image.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-740" />
      </main>
      <Footer data-id="element-741" />
    </div>;
}